import { useState } from 'react';
import './InputSearch.css'

const InputSearch = ({ value='', isDisabled=false, placeholder = 'Search keyword', onChange, onSearch=()=>{}, onBlur, onFocus, error }) => {
  const [showError, setShowError] = useState(false);
  
  const isSearchDisabled = isDisabled || !!error;

  const onKeyDown = (event) => {
    if (event.key === 'Enter' && !isSearchDisabled) {
      event.preventDefault();
      onSearch(value);
    }
  };

  const handleSearchClick = () => {
    if (!isSearchDisabled) {
      onSearch(value);
    }
  };

  const handleIconMouseEnter = () => setShowError(true);
  const handleIconMouseLeave = () => setShowError(false);
  const handleIconClick = () => setShowError(prevState => !prevState);

  return (
    <div className={`input-search-container${error ? ' validation-error' : ''}`}>
      <input
        type="text"
        className="input-search-field"
        disabled={isDisabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <button
        type="button"
        className="input-search-button"
        onClick={handleSearchClick}
        disabled={isSearchDisabled}
      >
        <i className="bx bx-search input-search-icon" />
      </button>

      {}
      {error && (
        <div
          className="validation-error-icon"
          onMouseEnter={handleIconMouseEnter}
          onMouseLeave={handleIconMouseLeave}
          onClick={handleIconClick}
        >
          <span className="validation-error-icon-inner">!</span>
          {
            <div className={`validation-error-message${showError ? ' visible' : ''}`}>
              <span>{error?.shortMessage ?? ''}</span>
            </div>
          }
        </div>
      )}
    </div>
  );
};

export default InputSearch;
